import { AnyAction, Dispatch } from 'redux';
import { SidePanelState } from '../reducer/sidePanelReducer';
import {
  PiFileTextLight,
  PiUserPlusLight,
  PiSlidersHorizontalLight,
} from 'react-icons/pi';

export const showSidePanel = (payload: SidePanelState): AnyAction => ({
  type: 'SHOW_SIDE_PANEL',
  payload,
});

export const hideSidePanel = (): AnyAction => ({
  type: 'HIDE_SIDE_PANEL',
});

export const expandSidePanel = (): AnyAction => ({
  type: 'EXPAND_SIDE_PANEL',
});

export const collapseSidePanel = (): AnyAction => ({
  type: 'COLLAPSE_SIDE_PANEL',
});

export const updateSidePanel = (payload: Partial<SidePanelState>): AnyAction => ({
  type: 'UPDATE_SIDE_PANEL',
  payload,
});

export const showAddClientSidePanel = (onClientCreated?: (client: any) => void) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'addClient',
        showSidePanel: true,
        width: '50%',
        onCancel: () => dispatch(hideSidePanel()),
        onClientCreated: onClientCreated,
        icon: <PiUserPlusLight className='w-6 h-6 text-gray-600' />,
        message: 'Create New Client',
        subMsg: 'Fill in the detals to create a new client.'
      })
    );
  };
};


export const showTimekeepingSidePanel = (day: string | null, data: any, isLoading: boolean, stats: any) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'timekeepingView',
        showSidePanel: true,
        width: '50%',
        isExpanded: false,
        onCancel: () => dispatch(hideSidePanel()),
        day,
        data,
        isLoading,
        stats
      })
    );
  };
};

export const showCreateLCMCaseSidePanel = () => ({
  type: 'SHOW_SIDE_PANEL',
  payload: {
    type: 'createLCMCase',
    width: '50%',
    isExpanded: false,
  },
});

export const showCreateProjectSidePanel = () => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'createProject',
        showSidePanel: true,
        width: '50%',
        onCancel: () => dispatch(hideSidePanel()),
      })
    );
  };
};

export const showProposeCaseSidePanel = (lawyerId: string) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'proposeCase',
        showSidePanel: true,
        width: '50%',
        onCancel: () => dispatch(hideSidePanel()),
        lawyerId,
      })
    );
  };
};


export const showFileReaderSidePanel = (fileUrl: string, fileType: string) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'fileReader',
        showSidePanel: true,
        width: '50%',
        fileType: fileType || '',
        fileUrl,
        onCancel: () => dispatch(hideSidePanel()),
        loading: true,
      })
    );
  };
};

export const showExtractedContentSidePanel = (filename: string, extractedText: string) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'extractedContent',
        showSidePanel: true,
        width: '50%',
        message: filename,
        icon: <PiFileTextLight className='w-6 h-6 text-gray-600' />,
        filename,
        content: extractedText,
        onCancel: () => dispatch(hideSidePanel()),
      })
    );
  };
};

export const ShowTransactionDetailsPanel = (transaction_id: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showSidePanel({
      type: 'transactionDetails',
      showSidePanel: true,
      width: '50%',
      onConfirm: () => { },
      onCancel: () => { },
      transaction_id: transaction_id,
    }));
  }
};

export const showDocumentCustomizationPanel = (
  matterUuid: string,
  documentTypeId: string,
  documentType: 'draft' | 'insight',
  documentName: string,
) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'documentCustomization',
        showSidePanel: true,
        width: '50%',
        mb: false,
        matterUuid,
        documentTypeId,
        documentType,
        documentName,
        message: `Customize ${documentName}`,
        icon: <PiSlidersHorizontalLight className="w-6 h-6 text-gray-600" />,
        subMsg: `Configure custom instructions and reference attachments for this ${documentType}.`,
        onCancel: () => dispatch(hideSidePanel()),
      })
    );
  };
};
